import GE from "./Ge";
import AIA from "./Aia";
import RHI from "./RHI";

export const HDF_MAP = {
  GEHDMOREDEP2018: GE,
  GEHD201808: GE,
  AIAHD201706_NOCHILD: AIA,
  AIAHD201906: AIA,
  RHIHD201907: RHI,
};

export const CSS_MAP = {
  AIAHD201611: "aia.css",
  AIAHD201706_NOCHILD: "aia.css",
  AIAHD201706: "aia.css",
  AVIVAHD201407: "aviva-ge.css",
  GEHD201412: "aviva-ge.css",
  GEHD201708: "aviva-ge.css",
  GEHDMOREDEP2018: "aviva-ge.css",
  GEHD201808: "aviva-ge.css",
  PRUHD201611: "prudential.css",
  TMLHD201702: "tokiomarine.css",
};

export const CLOSE_MESSAGE = [
  "You are about to close the Health Declaration Form.\n",
  "Any changes that is not saved will be lost.\n",
  "Proceed?",
].join("");

export const SUBMIT_FAILURE_MESSAGE = [
  "The form failed to submit. ",
  "Please ensure you have completed all required fields as marked.",
].join("");



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/constants.js